// extracted by mini-css-extract-plugin
export default {"languages":"Language_languages__dfLgV","language":"Language_language__VV3u9","active":"Language_active__x38FY"};